export enum CLCHubGroupTypes {
  HEADER = 'header',
  FOOTER = 'footer',
  GENERAL = 'general',
  LOGIN = 'login',
  REGISTER = 'register',
}

export enum CLCHubSectionTypes {
  NAVIGATION = 'navigation',
  BRANDING = 'branding',
  TYPOGRAPHY = 'typography',
  COLORS = 'colors',
  CUSTOM_CSS = 'custom_css',
  FOOTER = 'footer',
  LOGIN_MAIN = 'login_main',
  REGISTER_MAIN = 'register_main',
}
